module.exports = __webpack_public_path__ + "static/media/lettuce.494d333b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/accessory_image/base/lettuce.jpg
// module id = 98
// module chunks = 0